import "./styles.sass";
import useHandler from "./handler";
import assets from "../../assets";
import { ROUTE_CHECK_MAIL } from "../../route";
import React, { useEffect } from "react";
import { ROUTE_DASHBOARD } from "../../route/studentRoute";
import { ROUTE_DASHBOARD as TnpscRoute } from "../../route/tnpscRoute";
import { ROUTE_DASHBOARD as NeetJ2ERoute } from "../../route/neetJteRoute";
import { ROUTE_DASHBOARD as BankinRoutes } from "../../route/bankingRoute";
import {
  ROUTE_STUDENT_MANAGEMENT,
  ROUTE_DASHBOARD as ROUTE_USER_DASHBOARD,
} from "../../route";
import { ROUTE_DASHBOARD as teacherRouter } from "../../route/teacherRoute";
import { ROUTE_DASHBOARD as communicateDasboard } from "../../route/communicative";
import AccountCreate from "../account-create";

export const NewLogin = () => {
  const {
    data,
    showPassword,
    error,
    isLoading,
    shouldRenderSplash,
    showSplash,
    loginType,
    role,
    board,
    examType,
    isSignUpMode,
    loading,
    setIsSignUpMode,
    setShowPassword,
    onChangeValue,
    onSubmit,
    toggleCheck,
    onResetPassword,
    navigate,
    setLoginType,
  } = useHandler();

  const { email, password, username, check } = data;
  const { errEmail, errPassword, errUserName } = error;

  useEffect(() => {
    if (role === "student") {
      navigate(ROUTE_USER_DASHBOARD, { replace: true });
    } else if (role === "aspirant" && examType?.startsWith("TNPSC")) {
      navigate(TnpscRoute, { replace: true });
    } else if (role === "aspirant" && examType?.startsWith("UPSC")) {
      navigate(ROUTE_DASHBOARD, { replace: true });
    } else if (role === "aspirant" && (board === "NEET" || board === "JEE")) {
      navigate(NeetJ2ERoute, { replace: true });
    } else if (role === "admin") {
      navigate(ROUTE_STUDENT_MANAGEMENT, { replace: true });
    } else if (role === "guest" && examType?.startsWith("TNPSC")) {
      navigate(TnpscRoute, { replace: true });
    } else if (role === "guest" && examType?.startsWith("UPSC")) {
      navigate(ROUTE_DASHBOARD, { replace: true });
    } else if (
      role === "guest" &&
      (examType?.startsWith("NEET") || examType?.startsWith("JEE"))
    ) {
      navigate(NeetJ2ERoute, { replace: true });
    } else if (
      role === "guest" &&
      (examType?.startsWith("CBSE") || examType?.startsWith("TN_STATE_BOARD"))
    ) {
      navigate(ROUTE_USER_DASHBOARD, { replace: true });
    } else if (
      role === "aspirant" &&
      (board === "Banking" || examType?.startsWith("Banking"))
    ) {
      navigate(BankinRoutes, { replace: true });
    } else if (role === "teacher") {
      navigate(teacherRouter, { replace: true });
    } else if (
      role === "ce_user" &&
      examType?.startsWith("Communicative English")
    ) {
      navigate(communicateDasboard, { replace: true });
    } else if (
      role === "guest" &&
      examType?.startsWith("Communicative English")
    ) {
      navigate(communicateDasboard, { replace: true });
    }
  }, [role, board, examType, navigate]);

  return (
    <React.Fragment>
      {shouldRenderSplash && (
        <div
          className={`rovian_splash_container ${!showSplash ? "fade_out" : ""}`}
        >
          <div className="splash_content">
            <h1 className="rovian_text">ROVIAN</h1>
            <div className="loading_bar_container">
              <div className="loading_bar_fill"></div>
            </div>
          </div>
        </div>
      )}
      <section
        className={`main_login_container ${isSignUpMode ? "sign-up-mode" : ""} ${showSplash ? "hidden_content" : "visible_content"}`}
      >
        <section
          className={`new_login ${isSignUpMode ? "move_left" : "move_right"}`}
        >
          <section className="new_login_card">
            <section className="new_login_logo">
              <section className="new_login_logo_icon">📚</section>
              <h5>Rovian EduSuite</h5>
            </section>

            <h2>Welcome </h2>

            {/* <p>Log in with the password from your email.</p> */}
            <p>
              Log in to continue your learning journey, access courses, quizzes,
              and track your progress.
            </p>

            {/* <section className="new_login_tabs">
            <button
              className={loginType === "email" ? "active" : ""}
              onClick={() => setLoginType("email")}
            >
              Email
            </button>

            <button
              className={loginType === "username" ? "active" : ""}
              onClick={() => setLoginType("username")}
            >
              Username / Phone
            </button>
          </section> */}

            <section className="new_login_form_group">
              <label>
                {" "}
                {/* {loginType === "email"
                ? "Email Address"
                : "Username or Phone Number"} */}
                {"Email / Username / Phone Number"}
              </label>
              <input
                // type={loginType === "email" ? "email" : "text"}
                type={"text"}
                // placeholder={
                //   loginType === "email"
                //     ? "you@example.com"
                //     : "Enter username or phone number"
                // }
                placeholder={"e.g. alex@email.com"}
                // name={loginType === "email" ? "email" : "username"}
                name={"username"}
                // value={loginType === "email" ? email : username}
                value={username}
                onChange={onChangeValue}
              />
              {/* {loginType === email ? <p>{errEmail}</p> : <p>{errUserName}</p>} */}
              {<p>{errUserName}</p>}
            </section>

            <section className="new_login_form_group">
              <label>Password</label>
              <section className="new_password_input">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password from email"
                  name="password"
                  value={password}
                  onChange={onChangeValue}
                />
                <img
                  src={showPassword ? assets.ic_eye : assets.ic_closed_eye}
                  alt="toggle"
                  className="eye_toggle"
                  onClick={() => setShowPassword(!showPassword)}
                />
              </section>
              {errPassword && <p>{errPassword}</p>}
            </section>

            <section className="new_login_options">
              {/* <section className="remember_me">
              <input type="checkbox" />
              <h5>Remember me</h5>
            </section> */}
              <section className="forgot-txt">
                Forgot Your Password?
                <span
                  className="new_forgot_password"
                  onClick={() =>
                    navigate(`${ROUTE_CHECK_MAIL}?isForgot=${true}`)
                  }
                >
                  {" "}
                  &nbsp; Click Here
                </span>
              </section>
            </section>

            <section className="new_login_btn" onClick={onSubmit}>
              {loading && <section className="new_login_loader"></section>}
              Log in
            </section>

            <section className="new_signup">
              New here?{" "}
              {/* <span onClick={() => navigate(ROUTE_ACCOUNT_CREATE)}> */}
              <span onClick={() => setIsSignUpMode(true)}>Create account</span>
            </section>
          </section>
        </section>
        {/* Signup */}
        <section
          className={`new_signup_page ${
            isSignUpMode ? "show_signup" : "hide_signup"
          }`}
        >
          <AccountCreate
            noWrapper={true}
            onBack={() => setIsSignUpMode(false)}
          />
        </section>
        <div className="panels-container">
          <div className="panel left-panel">
            <div className="content">
              <div className="brand_name">ROVIAN</div>
              <p>
                Your AI-powered learning journey starts here. Join Rovian and
                master any subject at your own pace.
              </p>
              <button
                className="btn transparent"
                onClick={() => setIsSignUpMode(true)}
              >
                Sign Up
              </button>
            </div>
            <img
              src={assets.img_student_going_to_school}
              className="image"
              alt="Learning illustration"
            />
          </div>
          <div className="panel right-panel">
            <div className="content">
              <div className="brand_name">ROVIAN</div>
              <p>
                Welcome! Please sign in to access your account and resume your
                professional development.
              </p>
              <button
                className="btn transparent"
                onClick={() => setIsSignUpMode(false)}
              >
                Log In
              </button>
            </div>
            <img
              src={assets.img_digital_nomad}
              className="image"
              alt="Welcome illustration"
            />
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};
